import { Injectable } from "@angular/core";

import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from "@angular/router";
import { of } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { IDirty } from "../interfaces/idirty.interface";
import { ConfirmationDialogService } from "../modules/confirmation-dialog/confirmation-dialog.service";
import { LogService } from "../services/log.service";

@Injectable()
export class DirtyModelGuard implements CanDeactivate<IDirty> {

  constructor(
    private logger: LogService,
    private confirmationDialogService: ConfirmationDialogService
  ) {}

  public canDeactivate(
    component: IDirty,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    const canLeave = !component.isDirty();
    if (canLeave) {
      return of(true);
    }
    return this.confirmationDialogService.showModelIsDirtyDialog();
  }
}
